// this data is generated by the vue CLI and is only fired when wraped with npm run built and when it's running on a local server or a https:// domain

import { register } from 'register-service-worker';

// import vuex store to have acess to all data, it's no component so $store can't be used
import Store from '@/store';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    // ready() {
    // Store.commit('addToast', { message: 'App is being served from cache by a service worker. For more details, visit https://goo.gl/AFskqB' });
    // },
    // registered() {
    // Store.commit('addToast', { message: 'Serivce worker has been registered.' });
    // },
    // cached() { // when the app is available offline show this toast to inform the user
    //   Store.commit('addToast', { message: 'Rhythm has been cached on your device and is available offline.' });
    // },
    // updatefound() {
    // Store.commit('addToast', { message: 'New content is downloading' });
    // },
    async updated(registration) { // if the app is updated in the background
      Store.commit('addToast', { // show this toast
        action: () => { // that allows to reload the page
          if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload(true); // relaod page
        },
        actionLabel: 'ok', // show button with message in ''
        message: 'There is a new update available. Refresh to use the latest features.', // the message in the toast
      });
    },
    offline() {
      Store.commit('addToast', { message: 'No internet connection found. App is running offline.' });
    },
    error() {
      Store.commit('addToast', { message: 'Error during service worker registration.' });
    },
  });
}
